import { render, staticRenderFns } from "./robotData.vue?vue&type=template&id=d49c2dc8&scoped=true&"
import script from "./robotData.vue?vue&type=script&lang=js&"
export * from "./robotData.vue?vue&type=script&lang=js&"
import style0 from "./robotData.vue?vue&type=style&index=0&id=d49c2dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49c2dc8",
  null
  
)

export default component.exports